import Handlebars from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.6/js/handlebars";
import focusTrapUtility from "utilities/global/focus-trap-utility/1.2.3/js/focus-trap-utility";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.3/js/sparta-events-utility";
import "utilities/global/sparta-global-data-utility/1.0.0/js/sparta-global-data-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.2/js/sparta-global-functions-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/3.0.5/js/sparta-mediaquery-utility";
import spartaSingletonUtility from "utilities/global/sparta-singleton-utility/1.0.0/js/sparta-singleton-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/4.4.0/js/sparta-style-utility";
import cardHelper from "utilities/helpers/helpers-card/1.2.0/js/helpers-card";
import spartaHelpers from "utilities/helpers/helpers-sparta/3.0.5/js/helpers-sparta";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";



const instance = {};






const SpartaUILayersTooltip = {







  buildHTML: (utility, options, $link) => {
    const settings = new (function SettingsConstructor() {
      this.tooltipId = options.layerId;
      this.contentWrapperId = options.rel || 'tooltipContentInt';
      this.continueLink = $link.attr('href');
      this.anchorID = $link.attr('id');
      this.titleTag = 'h3';
      this.type = options.type;


      this.tooltipCloseText = `${options.closeText}`;
      this.tooltipAdaText = `${this.tooltipCloseText} ${options.closeAdaText}`.trim();

      this.classesToAdd = [
        options.layerClass,
        options.infoLayer.class,
        SpartaUILayersTooltip.getContentLength(options).sizeClass,
      ];


      this.content = options.$content.removeClass('hide').detach();


      this.title = $(options.$content).find(`#${options.contentId}_title`)
        ? $(options.$content).find(`#${options.contentId}_title`).html()
        : undefined;


      if (!this.title) {
        this.title = options.modalTitle || options.title;
      }
    })();

    if (settings.type === 'info-inline') {
      settings.classesToAdd.push(`spa-ui-info-${options.type}`)
    }


    if (settings.title) {
      settings.title = settings.title.trim();
      settings.title = `${settings.title.charAt(0).toUpperCase()}${settings.title.slice(1)}`;
    }


    const tooltipCardJCR = {
      dismissible: true,
      dismissibleADA: settings.tooltipAdaText || '',
      dismissibleClass: 'spa-ui-layer-close',
      class: (!settings.title)
        ? 'spa-ui-info--no-title'
        : '',
      title: settings.title || '',
      titleTag: settings.titleTag,
      markup: {
        content: ' ', 
      },
      config: {
        titleID: `${options.contentId}_title`,
      },
    };


    instance[settings.tooltipId] = settings;


    return SpartaUILayersTooltip.formatHTML(utility, options, settings, tooltipCardJCR);
  },









  formatHTML: (utility, options, settings, tooltipCardJcr) => {

    const tooltipLayerElement = document.createElement('div');
    tooltipLayerElement.id = options.layerId;
    tooltipLayerElement.style.zIndex = utility._getNextZindex(options);
    settings.classesToAdd.forEach((name) => {
      tooltipLayerElement.classList.add(name);
    });


    tooltipLayerElement.innerHTML = cardHelper.render(tooltipCardJcr).string;


    tooltipLayerElement.querySelector('.spa-card__body').appendChild(settings.content[0]);


    if (settings.title && tooltipLayerElement.querySelector('.spa-ui-layer-title')) {
      tooltipLayerElement.querySelector('.spa-ui-layer-title').remove();
    }


    tooltipLayerElement.firstElementChild.setAttribute('role', 'dialog');


    tooltipLayerElement.firstElementChild.setAttribute(
      'aria-labelledby',
      `${options.contentId}_title`,
    );


    if (tooltipLayerElement.querySelector('[data-modal-footer]')) {
      const tooltipFooterElement = utility.createStickyFooter(tooltipLayerElement, options);
      tooltipLayerElement.querySelector('.spa-card').appendChild(tooltipFooterElement);
    }


    return tooltipLayerElement;
  },






  getContentLength: (options) => {

    const contentEl = options.$content.find(' > :not(".ada-hidden")');
    const contentLength = contentEl ? contentEl.text().replace(/ {2,}/g, ' ').length : 0;

    let widthValue;
    let sizeClass;
    if (contentLength < options.infoLayer.width.small.chars) {
      widthValue = options.infoLayer.width.small.width;
      sizeClass = options.infoLayer.width.small.class;
    } else if (contentLength < options.infoLayer.width.medium.chars) {
      widthValue = options.infoLayer.width.medium.width;
      sizeClass = options.infoLayer.width.medium.class;
    } else {
      widthValue = options.infoLayer.width.large.width;
      sizeClass = options.infoLayer.width.large.class;
    }

    return {
      widthValue,
      sizeClass,
    };
  },






  createEndOfElement: (options) => {
    const tooltipEndOfElement = document.createElement('div');
    tooltipEndOfElement.classList.add('ada-hidden');
    if (options.endContentMsgShowOnFocus) {
      tooltipEndOfElement.classList.add('ada-visible-focus');
      tooltipEndOfElement.setAttribute('tabindex', '0');
    }
    tooltipEndOfElement.innerHTML = (`${options.endContentMsg}`);

    return tooltipEndOfElement;
  },









  setTitle($layer, titleText, updateAdaText, tooltipId) {

    const tooltipWrapper = $layer[0];
    const updateADA = updateAdaText;

    let options;
    if (tooltipId.includes('SpartaUILayer')) {
      options = instance[`${tooltipId}`];
    } else {
      options = instance[`${tooltipId}SpartaUILayer`];
    }

    if (!options) {
      return;
    }


    const tooltipTitle = tooltipWrapper.querySelector('.spa-card__title');
    const tooltipDismissible = tooltipWrapper.querySelector('.spa-card__dismissible');


    if (tooltipDismissible && updateADA && 'tooltipCloseText' in options) {
      tooltipDismissible.setAttribute('aria-label', `${options.tooltipCloseText}: ${titleText}`.trim());
    }


    if (tooltipTitle) {
      tooltipTitle.innerHTML = titleText;
    }
  },
};

export default SpartaUILayersTooltip;
